module.exports = __webpack_public_path__ + "static/img/news-cqw.55d14fe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/newsDetail/images/news-cqw.jpg
// module id = c+4L
// module chunks = 0